import React from 'react';
import { CompleteProfileAuth0 } from '../../components/auth/Profile/completeProfile';

export const UserProfileView = () => {
  return <CompleteProfileAuth0 />;
};
